import ReducersIndex from "reduxModules/ducks";
import { isInside } from "utilities/geometric";


//const items = ['measure', 'block', 'bulkedit', 'move', 'add', 'remove', 'ghostchair', 'listen', 'ghostdock', 'undo']
// todo: undo
const actions = {
  floorplan: {
    area: ['measure'],
  },
  ceiling: {
    area: ['measure', 'block']
  },
  furnishing: {
    area: ['measure', 'bulkedit', 'move', 'add', 'remove', 'ghostchair']
  },
  acoustics: {
    area: ['measure', 'position', 'level', 'distance', 'move', 'add', 'remove', 'listen']
  },
  microphones: {
    area: ['measure', 'position', 'distance', 'move', 'add', 'remove', 'listen']
  },
  speakers: {
    area: ['measure', 'position', 'level', 'move', 'add', 'remove']
  },
  equipmentlist: {}
};

export const conditions = {
  block: {parameter: ['ceilingTiles'], check: ([tiles]) => tiles.tile !== 'no_ceiling_tiles'},
  // todo: this only applies to rect, arch, round and oval
  // ghostchair: {parameter: ['table'], check: ([table]) => table.shape},
  level: {parameter: ['currentDevice', ], check: ([device]) => device === 'speakers'},
  distance:{parameter: ['currentDevice', ], check: ([device]) => device !== 'speakers'},
  add: {parameter: ['currentDevice', ], check: ([device]) => device !== 'cameras'},
  remove:{parameter: ['currentDevice', ], check: ([device]) => device !== 'cameras'},
  listen:{parameter: ['currentDevice', ], check: ([device]) => device === 'microphones'},
};

export const actionDispatchers = {
  /**
   * Dispatcher for the measure action.
   * Placeholder implementation for measuring distances.
   */
  measure: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Measure tool activated');
    // TODO: Implement measure functionality
  },

  /**
   * Dispatcher for the position action.
   * Shows positioning information for selected devices.
   */
  position: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Position info tool activated');
    // TODO: Implement position info display
  },

  /**
   * Dispatcher for the distance action.
   * Shows distance information for devices.
   */
  distance: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Distance info tool activated');
    // TODO: Implement distance info display
  },

  /**
   * Dispatcher for the level action.
   * Shows audio level information for speakers.
   */
  level: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Level info tool activated');
    // TODO: Implement level info display
  },

  /**
   * Dispatcher for the move action.
   * Enables moving devices within the room.
   */
  move: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Move tool activated');
    // TODO: Implement move functionality
  },

  /**
   * Dispatcher for the add action.
   * Adds new devices to the room.
   */
  add: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Add tool activated');
    // TODO: Implement add functionality
  },

  /**
   * Dispatcher for the remove action.
   * Removes devices from the room.
   */
  remove: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Remove tool activated');
    // TODO: Implement remove functionality
  },

  /**
   * Dispatcher for the listen action.
   * Shows listening pattern information for microphones.
   */
  listen: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Listen pattern tool activated');
    // TODO: Implement listen pattern display
  },

  /**
   * Dispatcher for the block action.
   * Blocks/unblocks ceiling tiles.
   */
  block: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Block tool activated');
    // TODO: Implement ceiling tile blocking
  },

  /**
   * Dispatcher for the bulkedit action.
   * Enables bulk editing operations.
   */
  bulkedit: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Bulk edit tool activated');
    // TODO: Implement bulk edit functionality
  },

  /**
   * Dispatcher for the ghostchair action.
   * Manages ghost chair functionality.
   */
  ghostchair: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Ghost chair tool activated');
    // TODO: Implement ghost chair functionality
  },

  // ghostdock: (_, dispatch, mouse) => {
  //   const target = document.getElementById('loadingdocks');
  //   const dock = Array.from(target.children).find(child => isInside(mouse, child.getBoundingClientRect()));
  //   if (dock) dispatch(ReducersIndex.container.setGhostDocks(dock.id));
  // },
  // remove: (evt, dispatch) => {
  //   const target = evt.target.closest('[class=speakers]')?.id;
  //   if (target) {
  //     const [area, _, speakerId] = target.split('-');
  //     dispatch(ReducersIndex.container.removeSpeaker({area: area, id: speakerId}));
  //   };
  // },
};

export default actions;
